import { render } from "./DonorProfile.vue?vue&type=template&id=72edc7ef"
import script from "./DonorProfile.vue?vue&type=script&lang=js"
export * from "./DonorProfile.vue?vue&type=script&lang=js"
script.render = render

export default script